// extracted by mini-css-extract-plugin
export var aircallIframe = "_k3-3";
export var fabContainer = "_k3-5";
export var fabRinging = "_k3-6";
export var loadingOverlay = "_k3-4";
export var pulse = "_k3-7";
export var widgetContent = "_k3-2";
export var widgetPanel = "_k3-0";
export var widgetPanelExpanded = "_k3-1";